import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

// TODO: Remove this block and update build optimizations (EC-5928)
// if (environment.production) {
enableProdMode();
// }

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error('[Main.ts] bootstrapModule(): ', err));
